import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
  Palette,
  X,
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
import RangeSliderValueResolutionUI from "./RangeSliderValueResolutionUI";
import ColorPickerDynamicTwo from "../../../UI/ColorPicker/ColorPickerDynamicTwo";
import ColorPickerGradientDynamic from "../../../UI/ColorPicker/ColorPickerGradientDynamic";
import DropDownButtonUI from "./DropDownButtonUI";
const AnimationBoxUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);


     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);

 return(<>


                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{displayName} </h4></div>
                                                <div  style={{display:"flex",justifyContent:"space-around"}}>
           <div > 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px",display:"flex",justifyContent:"space-around"}} >
                                          
                                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIGoUp" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="goUp"?"yes":""
                            }
                   className="input-textbox"  value={"goUp"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("goUp",`${objectName}Type`);
                   setItemValue("goUp");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                              
                                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIGoDown" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="goDown"?"yes":""
                            }
                   className="input-textbox"  value={"goDown"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("goDown",`${objectName}Type`);
                   setItemValue("goDown");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                             
                                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIGoLeft" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="goLeft"?"yes":""
                            }
                   className="input-textbox"  value={"goLeft"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("goLeft",`${objectName}Type`);
                   setItemValue("goLeft");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                             
                                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIGoRight" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="goRight"?"yes":""
                            }
                   className="input-textbox"  value={"goRight"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("goRight",`${objectName}Type`);
                   setItemValue("goRight");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                             

                              <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIZoomIn" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="zoomIn"?"yes":""
                            }
                   className="input-textbox"  value={"zoomIn"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("zoomIn",`${objectName}Type`);
                   setItemValue("zoomIn");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>

                         <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIZoomOut" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="zoomOut"?"yes":""
                            }
                   className="input-textbox"  value={"zoomOut"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("zoomOut",`${objectName}Type`);
                   setItemValue("zoomOut");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    </div> <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px",display:"flex",justifyContent:"space-around"}} >
                        
                         <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISkewHorizontal" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="skewHorizontal"?"yes":""
                            }
                   className="input-textbox"  value={"skewHorizontal"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("skewHorizontal",`${objectName}Type`);
                   setItemValue("skewHorizontal");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                         <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISkewVertical" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="skewVertical"?"yes":""
                            }
                   className="input-textbox"  value={"skewVertical"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("skewVertical",`${objectName}Type`);
                   setItemValue("skewVertical");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIFlipHorizontal" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="flipHorizontal"?"yes":""
                            }
                   className="input-textbox"  value={"flipHorizontal"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("flipHorizontal",`${objectName}Type`);
                   setItemValue("flipHorizontal");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                         <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIFlipVertical" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="flipVertical"?"yes":""
                            }
                   className="input-textbox"  value={"flipVertical"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("flipVertical",`${objectName}Type`);
                   setItemValue("flipVertical");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                       <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISpinLeft" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="spinLeft"?"yes":""
                            }
                   className="input-textbox"  value={"spinLeft"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("spinLeft",`${objectName}Type`);
                   setItemValue("spinLeft");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                       <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISpinRight" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="spinRight"?"yes":""
                            }
                   className="input-textbox"  value={"spinRight"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("spinRight",`${objectName}Type`);
                   setItemValue("spinRight");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                    
                      </div> <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px",display:"flex",justifyContent:"space-around"}} >

                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideUpZoom" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideUpZoom"?"yes":""
                            }
                   className="input-textbox"  value={"slideUpZoom"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideUpZoom",`${objectName}Type`);
                   setItemValue("slideUpZoom");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideDownZoom" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideDownZoom"?"yes":""
                            }
                   className="input-textbox"  value={"slideDownZoom"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideDownZoom",`${objectName}Type`);
                   setItemValue("slideDownZoom");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideLeftZoom" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideLeftZoom"?"yes":""
                            }
                   className="input-textbox"  value={"slideLeftZoom"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideLeftZoom",`${objectName}Type`);
                   setItemValue("slideLeftZoom");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideRightZoom" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideRightZoom"?"yes":""
                            }
                   className="input-textbox"  value={"slideRightZoom"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideRightZoom",`${objectName}Type`);
                   setItemValue("slideRightZoom");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    


  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideUpSkew" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideUpSkew"?"yes":""
                            }
                   className="input-textbox"  value={"slideUpSkew"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideUpSkew",`${objectName}Type`);
                   setItemValue("slideUpSkew");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideDownSkew" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideDownSkew"?"yes":""
                            }
                   className="input-textbox"  value={"slideDownSkew"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideDownSkew",`${objectName}Type`);
                   setItemValue("slideDownSkew");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                      </div> <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px",display:"flex",justifyContent:"space-around"}} >
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideLeftSkew" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideLeftSkew"?"yes":""
                            }
                   className="input-textbox"  value={"slideLeftSkew"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideLeftSkew",`${objectName}Type`);
                   setItemValue("slideLeftSkew");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideRightSkew" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideRightSkew"?"yes":""
                            }
                   className="input-textbox"  value={"slideRightSkew"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideRightSkew",`${objectName}Type`);
                   setItemValue("slideRightSkew");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                      <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideUpRotate" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideUpRotate"?"yes":""
                            }
                   className="input-textbox"  value={"slideUpRotate"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideUpRotate",`${objectName}Type`);
                   setItemValue("slideUpRotate");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideDownRotate" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideDownRotate"?"yes":""
                            }
                   className="input-textbox"  value={"slideDownRotate"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideDownRotate",`${objectName}Type`);
                   setItemValue("slideDownRotate");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideLeftRotate" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideLeftRotate"?"yes":""
                            }
                   className="input-textbox"  value={"slideLeftRotate"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideLeftRotate",`${objectName}Type`);
                   setItemValue("slideLeftRotate");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideRightRotate" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideRightRotate"?"yes":""
                            }
                   className="input-textbox"  value={"slideRightRotate"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideRightRotate",`${objectName}Type`);
                   setItemValue("slideRightRotate");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    



  </div> <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px",display:"flex",justifyContent:"space-around"}} >

                      <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideUpFlip" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideUpFlip"?"yes":""
                            }
                   className="input-textbox"  value={"slideUpFlip"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideUpFlip",`${objectName}Type`);
                   setItemValue("slideUpFlip");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideDownFlip" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideDownFlip"?"yes":""
                            }
                   className="input-textbox"  value={"slideDownFlip"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideDownFlip",`${objectName}Type`);
                   setItemValue("slideDownFlip");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideLeftFlip" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideLeftFlip"?"yes":""
                            }
                   className="input-textbox"  value={"slideLeftFlip"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideLeftFlip",`${objectName}Type`);
                   setItemValue("slideLeftFlip");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                     <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUISlideRightFlip" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideRightFlip"?"yes":""
                            }
                   className="input-textbox"  value={"slideRightFlip"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("slideRightFlip",`${objectName}Type`);
                   setItemValue("slideRightFlip");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                      <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two AnimateUI"}
                               style={{display:"flex",justifyContent:"center",alignItems:"center",
                               }}>
                                             <div className="AnimateUIBlank" style={{}} >
                                              
                                                                     </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue=="slideRightBlank"?"yes":""
                            }
                   className="input-textbox"  value={"slideRightBlank"}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue("",`${objectName}Type`);
                   setItemValue("slideRightBlank");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                    
                    <label style={{width:"30px"}}></label>
                         </div>
                       
                        </div> </div>

      
                                 </>)

    } 
    export default AnimationBoxUI;

                     